import factory from './icon';
import StarSvg from './glyphs/star-black.svg';
import StarOutlineSvg from './glyphs/star-outline-black.svg';
import StarHalfSvg from './glyphs/star-half-black.svg';

export const StarBlack = factory(StarSvg);
export const StarOutlineBlack = factory(StarOutlineSvg);
export const HalfStarBlack = factory(StarHalfSvg);
